import { SourcingScenarioDTO } from '@luminovo/http-client';
import { calculateTotalOrderSize } from './calculateTotalOrderSize';

export const compareByTotalOrderSize = (a: SourcingScenarioDTO, b: SourcingScenarioDTO) => {
    return calculateTotalOrderSize(a) - calculateTotalOrderSize(b);
};
